function returnOptions(data, type) {
  // type-1是项目,2是产品
  const a = data.pcSaleCount + data.appSaleCount;
  const pcSaleRato = `${Math.round(data.pcSaleCount / a * 10000) / 100.00}%`;// 小数点后两位百分比
  const appSaleRato = `${Math.round(data.appSaleCount / a * 10000) / 100.00}%`;// 小数点后两位百分比
  // 这里判断有无值，设置无数据样式展示
  const showed = !!(data.pcSaleCount == 0 && data.appSaleCount == 0);
  console.log('type', showed, data.pcSaleCount, data.appSaleCount);
  return {
    color: ['#fe6d6c', '#339cf2'],
    title: {
      show: showed, // 是否显示title
      text: '暂无数据',
      left: 'center',
      top: 'center',
      textStyle: {
        color: '#909399',
        fontSize: 16,
        fontWeight: 400
      }
    },
    tooltip: {
      trigger: 'item',
      formatter(param) {
        let res = '';
        if (param.seriesName === '电脑端') {
          res = `${type == 1 ? '项目' : '产品'}销售量：${param.data}<br/>占比：${pcSaleRato}`;
        } else {
          res = `${type == 1 ? '项目' : '产品'}销售量：${param.data}<br/>占比：${appSaleRato}`;
        }
        return res;
      }
    },
    legend: {
      data: ['电脑端', '店员端'],
    },
    grid: {
      right: '0%',
      containLabel: true
    },
    xAxis: {
      show: false,
      type: 'value',
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      splitLine: {
        show: false
      }
    },
    yAxis: [
      {
        type: 'category',
        axisTick: { show: false },
        data: [],
        axisLine: {
          show: false,
        },
        splitLine: {
          show: false
        }
      }
    ],
    series: [
      {
        name: '电脑端',
        type: 'bar',
        stack: 'total',
        label: {
          show: false
        },
        emphasis: {
          focus: 'series'
        },
        data: [data.pcSaleCount]
      },
      {
        name: '店员端',
        type: 'bar',
        stack: 'total',
        label: {
          // show: true
          show: false,
        },
        emphasis: {
          focus: 'series'
        },
        data: [data.appSaleCount]
      },
    ]
  };
}
export const echartsB = returnOptions;
